import { useQuery } from '@apollo/client';
import {
    GET_WATER_USE_WATER_SYSTEM_INFO,
    GET_WATER_USE_WATER_SYSTEM_ANNUAL_USE,
    GET_WATER_USE_WATER_SYSTEM_PEAK_DATA,
} from '../../../queries/engineeringQrys';

/**
 * @param {string} pwsId - The full PWS ID (e.g., "UTAH12345")
 * @param {number[]} years - Array of years to fetch data for
 * @param {string[]} selectedSources - Optional array of selected source IDs
 */
const useDwriData = ({ pwsId, years, selectedSources = [] }) => {
    const skipInfo = !pwsId;
    const skipYearBased = !pwsId || years.length === 0;
    const sourceFilter = selectedSources.length > 0 ? selectedSources : undefined;

    const {
        data: infoData,
        loading: infoLoading,
        error: infoError,
    } = useQuery(GET_WATER_USE_WATER_SYSTEM_INFO, {
        variables: { pwsId },
        skip: skipInfo,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: annualUseData,
        loading: annualUseLoading,
        error: annualUseError,
    } = useQuery(GET_WATER_USE_WATER_SYSTEM_ANNUAL_USE, {
        variables: { pwsId, years, sources: sourceFilter },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: peakData,
        loading: peakLoading,
        error: peakError,
    } = useQuery(GET_WATER_USE_WATER_SYSTEM_PEAK_DATA, {
        variables: { pwsId, years, sources: sourceFilter },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    return {
        systemName: infoData?.getWaterUseSystemInfo?.systemName,
        sizingInfo: infoData?.getWaterUseSystemInfo?.sizingInfo,
        waterUses: annualUseData?.getWaterUseSystemAnnualUse?.WaterUses || [],
        sourceRecords: annualUseData?.getWaterUseSystemAnnualUse?.SourceRecords || [],
        peakDayData: peakData?.getWaterUseSystemPeakData?.peakDemand || [],
        peakMonthData: peakData?.getWaterUseSystemPeakData?.peakMonthDemand || [],
        loading: {
            info: infoLoading,
            annualUse: annualUseLoading,
            peak: peakLoading,
        },
        errors: {
            info: infoError,
            annualUse: annualUseError,
            peak: peakError,
        },
    };
};

export default useDwriData;
